import React from 'react'

import {
  Body1,
  Body2,
  Box,
  Color,
  Display,
  FlexDirection,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

type SidesAllergensProps = {
  sides: {
    id: string
    description: string
    title: string
  }[]
}

const WrappedBody = withCitrusTheme(Body2, () => ({
  whiteSpace: 'pre-wrap',
}))

export const SidesAllergens = ({ sides }: SidesAllergensProps) => (
  <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={4}>
    {sides.map(({ id, description, title }) => (
      <Box key={id}>
        <Body1 fontWeight={700} color={Color.ColdGrey_800}>
          {title}
        </Body1>
        <WrappedBody>{description}</WrappedBody>
      </Box>
    ))}
  </Box>
)
